import React from 'react';
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import Rating from "@material-ui/lab/Rating";
import withStyles from "@material-ui/core/styles/withStyles";
import FavoriteIcon from '@material-ui/icons/Favorite';

const StyledRating = withStyles({
    iconFilled: {
        color: '#ff6d75',
    },
    iconHover: {
        color: '#ff3d47',
    },
})(Rating);

const Review = ({readOnly, rating, text, name, date, activity}) => {

    return <Box display={'flex'} flexDirection={'column'} borderTop={'1px solid #80808040'} p={2}>
        <Box display={'flex'} justifyContent={'space-between'} alignItems={'flex-end'}>
        <Typography variant="subtitle1" color={'primary'} >{`${name} - ${activity}`}</Typography>
        <StyledRating
            name="customized-color"
            defaultValue={rating}
            readOnly={readOnly}
            icon={<FavoriteIcon fontSize="inherit"/>}
        />
        </Box>
        <Box display={'flex'} justifyContent={'space-between'} alignItems={'flex-end'}>
        <Typography component="legend">{text}</Typography>
        <Typography variant={'caption'}>{date}</Typography>
        </Box>
    </Box>
}

export default Review;